export const FAQ_ENDPOINTS = {
  getExposedList: "/faq/exposed",
  getFAQCategoryList: "/faq-category"
} as const

export const FAQ_KEYS = {
  all: ["faq"],
  exposedList: () => [...FAQ_KEYS.all, "exposedList"] as const,
  exposedListWithParams: (faqCategoryId: number) =>
    [...FAQ_KEYS.exposedList(), faqCategoryId] as const,
  faqCategoryList: () => [...FAQ_KEYS.all, "categoryList"] as const
} as const
